
<mat-dialog-content style="height:900px; max-height: 900px;  " >

   

    <div *ngIf="!loading && paymentdata" class="col-12">
        <h2 *ngIf="paymentdata.paymentType == 'PO'" class="po-header" mat-dialog-title tabindex="-1" >
            PO# {{ poList }}
          </h2>
   <div class="status-container">
          <div 
          class="status-pill"
          [ngClass]="statusKey(paymentdata.status)">
          {{ paymentdata.status }}
        </div>
    </div>

    <mat-tab-group class="custom-tabs" mat-align-tabs="center">
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>assignment</mat-icon>
            <span>Details</span>
          </ng-template>
          <div class="po-cards-container">
          
            <div class="po-card" *ngFor="let it of paymentdata.items">
              <span class="po-card-title">PO# {{ it.poInfo.po }}</span>
              <span class="po-card-amount">
                {{ it.originalTotalCostPo | currency:'USD':'symbol':'1.2-2' }}
              </span>
            </div>
        
            
            <div class="po-card total-card">
              <span class="po-card-title">
                Total&nbsp;<span class="gts-btn-icon-right">payments</span>
              </span>
              <span class="po-card-amount">
                {{ paymentdata.totalAmount | currency:'USD':'symbol':'1.2-2' }}
              </span>
            </div>
          </div>
          <div class="method-details" *ngIf="!loading && paymentdata.methodDetail">
            <h3>
              Payment method:
              {{ formatMethodType(paymentdata.methodDetail.methodType) }}
            </h3>
        
            <div class="grid-two-cols">
              <mat-form-field>
                <mat-label>$ Amount to be paid</mat-label>
                <input matInput
                       [value]="paymentdata.requestedAmount | currency:'USD':'symbol':'1.2-2'"
                       disabled>
              </mat-form-field>
          
              <mat-form-field>
                <mat-label>Payment Urgency</mat-label>
                <input matInput
                       [value]="addSpacesToLabel(paymentdata.paymentDueType)"
                       disabled>
              </mat-form-field>
          
              <mat-form-field>
                <mat-label>Invoice number (if available)</mat-label>
                <input matInput
                       [value]="paymentdata.methodDetail.invoiceNumber"
                       disabled>
              </mat-form-field>
              <mat-form-field>
                <mat-label>Vendor Company Name</mat-label>
                <input matInput
                       [value]="Clientname"
                       disabled>
              </mat-form-field>
            </div>
          
            
            <div [ngSwitch]="paymentdata.methodDetail.methodType">
          
              <!-- CHEQUES PICK-UP -->
              <ng-container *ngSwitchCase="'CHECK_PICKUP'">
               
                <div class="grid-two-cols">
                  <mat-form-field>
                    <mat-label>Number of checks needed</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.numberOfChecks"
                           disabled>
                  </mat-form-field>
                </div>
          
                
                <div class="grid-two-cols"
                     *ngFor="let chk of checks; let i = index">
                  <mat-form-field>
                    <mat-label>Check payable to</mat-label>
                    <input matInput [value]="chk.payableTo" disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Check amount</mat-label>
                    <input matInput
                           [value]="chk.amount  | currency:'USD':'symbol':'1.2-2'"
                           disabled>
                  </mat-form-field>
                </div>
          
               
                <div class="grid-two-cols">
                  <mat-form-field>
                    <mat-label>Pickup date/time</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.pickupDatetime | date:'short'"
                           disabled>
                  </mat-form-field>
                </div>
              </ng-container>
          
              <!-- CHEQUES MAILED -->
              <ng-container *ngSwitchCase="'CHECK_MAILED'">
                
                <div class="grid-two-cols">
                  <mat-form-field>
                    <mat-label>Number of checks needed</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.numberOfChecks"
                           disabled>
                  </mat-form-field>
                </div>
          
                <div class="grid-two-cols"
                     *ngFor="let chk of checks; let i = index">
                  <mat-form-field>
                    <mat-label>Check payable to</mat-label>
                    <input matInput [value]="chk.payableTo" disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Check amount</mat-label>
                    <input matInput
                           [value]="chk.amount  | currency:'USD':'symbol':'1.2-2'"
                           disabled>
                  </mat-form-field>
                </div>
          
                
                <div class="grid-two-cols">
                  <mat-form-field>
                    <mat-label>Shipping address</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.shippingAddress"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Shipping method</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.shippingMethod"
                           disabled>
                  </mat-form-field>
                </div>
              </ng-container>
          
              <!-- ACH DOMESTIC -->
              <ng-container *ngSwitchCase="'ACH_DOMESTIC'">
                <div class="grid-two-cols" *ngIf="paymentdata.methodDetail.modeform === 1">
                  <mat-form-field>
                    <mat-label>Beneficiary name</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.achBeneficiaryName"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Routing number</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.achRoutingNumber"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Account number</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.achAccountNumber"
                           disabled>
                  </mat-form-field>
                </div>
              </ng-container>
          
              <!-- WIRE INTERNATIONAL -->
              <ng-container *ngSwitchCase="'WT_INTERNATIONAL'">
                <div class="grid-two-cols" *ngIf="paymentdata.methodDetail.modeform === 1">
                  <mat-form-field>
                    <mat-label>Beneficiary name</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.wtBeneficiaryName"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Beneficiary address</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.wtBeneficiaryAddress"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>CLABE (Account)</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.wtClabe"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>SWIFT (Bank Code)</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.wtSwiftCode"
                           disabled>
                  </mat-form-field>
                </div>
              </ng-container>
          
              <!-- WIRE DOMESTIC -->
              <ng-container *ngSwitchCase="'WT_DOMESTIC'">
                <div class="grid-two-cols" *ngIf="paymentdata.methodDetail.modeform === 1">
                  <mat-form-field>
                    <mat-label>Beneficiary name</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.wtBeneficiaryName"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Beneficiary Address</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.wtDomesticBeneficiaryAddress"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Account number</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.wtDomesticAccountNumber"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Routing number</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.wtDomesticRoutingNumber"
                           disabled>
                  </mat-form-field>
                </div>
              </ng-container>
          
              <!-- PAYPAL -->
              <ng-container *ngSwitchCase="'PAYPAL'">
                <div class="grid-two-cols">
                  <mat-form-field>
                    <mat-label>Customer email</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.paypalEmail"
                           disabled>
                  </mat-form-field>
                </div>
              </ng-container>
          
              <!-- CREDIT CARD -->
              <ng-container *ngSwitchCase="'CREDIT_CARD'">
                <div class="grid-two-cols">
                  <mat-form-field>
                    <mat-label>AR department contact</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.ccContactName"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>Phone number</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.ccPhoneNumber"
                           disabled>
                  </mat-form-field>
                  <mat-form-field>
                    <mat-label>AR department email</mat-label>
                    <input matInput
                           [value]="paymentdata.methodDetail.ccContactEmail"
                           disabled>
                  </mat-form-field>
                </div>
              </ng-container>
          
            </div>
          </div>
          <div class="button-row">
              <button
                  class="gts-btn-primary-outline"
                  style="font-size:smaller;"
                  matRipple
                  *ngIf="showReject && (guard.permissions('approve-reject'))"
                  (click)="confirmReject()">
                  <span class="gts-btn-icon-left">close</span>
                  <span class="gts-btn-text">Reject</span>
                </button>
              <button
                  class="gts-btn-primary"
                  style="font-size:smaller;"
                  matRipple
                  *ngIf="showApprove && (guard.permissions('approve-reject'))"
                  (click)="confirmApprove()">
                  <span class="gts-btn-icon-left">check</span>
                  <span class="gts-btn-text">Approve</span>
                </button>
                <button
                matRipple
                class="gts-btn-primary"
                *ngIf="showPaid"
                (click)="confirmPaid()">
                <span class="gts-btn-icon-left">paid</span>
                <span class="gts-btn-text">Paid</span>
              </button>
            </div>
         
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>comment</mat-icon>
            <span>Notes</span>
          </ng-template>
          <app-comments
          [id_phather]="this.notesFatherId"
          [type_chat]="this.notesType"
          [type_notification]="this.notesType"
        >
        </app-comments>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>description</mat-icon>
            <span>Files</span>
          </ng-template>
       <app-multi-files [idfather]="data.id" [type]="this.notesType" ></app-multi-files>
        </mat-tab>
        <mat-tab>
          <ng-template mat-tab-label>
            <mat-icon>history</mat-icon>
            <span>History</span>
          </ng-template>
        
          <ng-container *ngIf="!loading; else loadingTpl">
            <div class="history-container">
           
              <div *ngFor="let ev of history" class="history-item">
                <div class="item-header">
              
                  <span class="evt">{{ ev.action }}</span>
                 
                  <span class="ts">{{ ev.timestamp | date:'dd/MM/yyyy HH:mm' }}</span>
                </div>
                <div class="item-body">
              
                  {{ ev.action }} by:
                  {{ ev.actorUser.name }} {{ ev.actorUser.surname }}
                 
                  <span *ngIf="ev.note">— Note: {{ ev.note }}</span>
                </div>
              </div>
            </div>
          </ng-container>
        
          <ng-template #loadingTpl>
            <div class="loading-history">
              <mat-progress-spinner diameter="40" mode="indeterminate"></mat-progress-spinner>
            </div>
          </ng-template>
        </mat-tab>
        
      </mat-tab-group>
    </div>

    <ngx-skeleton-loader
    *ngIf="loading"
    count="10"
    appearance="line"
    animation="pulse">
  </ngx-skeleton-loader>
  <!-- <ng-template #errorTpl>
    <p class="text-danger">No se pudo cargar la información del pago.</p>
  </ng-template> -->
</mat-dialog-content>
